import React from "react"
import Overview from "./Tabs/Overview";
import { useAccount } from "./Contexts/AccountContext";
import Sidebar from "./Components/Sidebar";
import ZooPass from "./Tabs/ZooPass";
import ClassesNEvents from "./Tabs/ClassesNEvents";

export default () => {
    const { selectedTab, dictionary, dispatch  } = useAccount();
    const routes = {
        overview: {
          element: <Overview />,
          name: dictionary.get('MyAccount:Tab:Overview') || 'Overview'
        },
        zoopass: {
          element: <ZooPass />,
          name: dictionary.get('MyAccount:Tab:ZooPass') || 'Zoo Pass'
        },
        events: {
          element: <ClassesNEvents />,
          name: dictionary.get('MyAccount:Tab:ClassNEvents') || 'Classes & Events'
        }
    }

    const caretDisplay = (up: boolean) => {
      return up ? <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-up-fill" viewBox="0 0 16 16">
        <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
      </svg>: <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-down-fill" viewBox="0 0 16 16">
        <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
      </svg>
    }

    return <div className="myaccount-wrapper">
        <div className="container">        
        {/* Content Row */}
        <div className="row">
          {/* Sidebar Column */}
          <div className="d-none d-sm-block col-sm-4 col-md-3 col-lg-2">
            <Sidebar />
          </div>
          
          {/* Main Content Column */}
          <div className="col-12 col-sm-8 col-md-9 col-lg-10">
            {Object.entries(routes).map(([key, route]) => (
              <div key={key}>
                <button 
                  key={key} 
                  className={`d-flex d-sm-none justify-content-between btn w-100 mb-2 ${selectedTab === key ? 'btn-success' : 'btn-default'}`}
                  onClick={() => dispatch({ type: 'selected-tab', data: key == selectedTab ? null : key })}
                >
                  <span>{route.name}</span><span>{caretDisplay(selectedTab == key)}</span>
                </button>
                {key == selectedTab && (<div className="mb-3">{route.element || <Overview />}</div>) /* Render the selected tab content */}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
}